import Vue from 'vue'
let pad_vue;

export default function msgpad_show(group,title,text,type){
	if(!pad_vue){
		pad_vue = new Vue({});
	}
	pad_vue.$notify({ group:group, title:title, text:text, type :type});
}


// WEBPACK FOOTER //
// ./src/msgpad_show.js